import toastStyle from "../../styles/toaster.module.css";
import { ReactComponent as ErrorCloseIcon } from "../../assets/icons/close_red.svg";
import { ReactComponent as SuccessCloseIcon } from "../../assets/icons/close_purple.svg";

const ToastNotification = ({
  title,
  children,
  removeError,
  variant = "error",
}: {
  title: string;
  children: React.ReactNode;
  removeError: () => void;
  variant?: "success" | "error" | "pending" | "info";
}) => {
  const isErrorVariant = variant === "error";
  const toastClass = isErrorVariant
    ? toastStyle.toast
    : `${toastStyle.toast} ${toastStyle.success}`;

  return (
    <div className={toastClass}>
      <div className="flex justify-between">
        <h3 className={toastStyle.toastTitle}>{title}</h3>
        <button onClick={() => removeError()}>
          {isErrorVariant ? <ErrorCloseIcon /> : <SuccessCloseIcon />}
        </button>
      </div>
      {children}
    </div>
  );
};

export default ToastNotification;
